// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"735":"fc33a4049ef13d94","754":"558df357b3b21655"}[chunkId] + ".js";
};